module.exports = __webpack_public_path__ + "static/instagram-round-line-icon-white-b7fee173a00dae85e2969ddf9b3e708a.png";